module.exports = __webpack_public_path__ + "static/media/info.ac07224a.svg";